import { useLocation } from "react-router-dom";

import { Alert, Box, Divider, Stack } from "@seneca/senekit";

import { ReactComponent as BlackboardImg } from "common/assets/images/sign-up/passwordless/blackboard.svg";

import useIsAndroidAppRunningInsideWebView from "features/pwa/mobile/android/hooks/useIsAndroidAppRunningInsideWebView";
import { ErrorMessage } from "features/sign-up/common-routes/components/form";
import { SignUpCardContent } from "features/sign-up/common-routes/components/Layout";

import { RenderSignInFormProps } from "../../../SignInCardCommon";

type Props = Pick<RenderSignInFormProps, "errorMessage"> & {
  children: {
    header: React.ReactNode;
    ssoButtons: React.ReactNode;
    bottomLink: React.ReactNode;
    emailButton: React.ReactNode;
  };
};

export default function SignInOptionsCard(props: Props) {
  const location = useLocation();
  const { children } = props;

  const errorMessageState = location.state?.errorMessage;

  const errorMessage = !!errorMessageState
    ? { message: errorMessageState }
    : props.errorMessage;

  const isSSOSupported = !useIsAndroidAppRunningInsideWebView();

  return (
    <SignUpCardContent>
      {{
        body: (
          <Stack align="center" space="large">
            {children.header}
            <BlackboardImg />
          </Stack>
        ),
        footer: (
          <Stack space="large">
            {isSSOSupported && errorMessage && (
              <Box width="100%">
                <ErrorMessage errorMessage={errorMessage} />
              </Box>
            )}
            <Stack space="xxlarge">
              {!isSSOSupported ? (
                <Alert iconName="info">
                  Google and Microsoft authentication methods are not supported
                  by this browser, please use Chrome browser instead
                </Alert>
              ) : (
                <Stack space="xxlarge">
                  {children.ssoButtons}
                  <Divider direction="horizontal" includeOr />
                </Stack>
              )}

              {children.emailButton}

              {children.bottomLink}
            </Stack>
          </Stack>
        )
      }}
    </SignUpCardContent>
  );
}
